import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../services/toast.service';

import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-mars-incident-list',
  templateUrl: './mars-incident-list.component.html',
  styleUrls: ['./mars-incident-list.component.scss']
})
export class MarsIncidentListComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = true;
  isAdmin = false;
  incidents = [];
  selectedBase = {
    baseId: 0,
    baseCode: '',
    value: ''
  };
  bases;
  modal = {
    active: false,
    data: {}
  };
  // selectedYear = {
  //   name: 2004,
  //   value: 2004
  // };
  // years = [];

  public basesXref = [];

  headings = [
    {
      label: 'Incident ID',
      key: 'incidentId',
      type: 'number'
    },
    {
      label: 'Date',
      key: 'incidentDate',
      type: 'date'
    },
    {
      label: 'Classification',
      key: 'classificationName'
    },
    {
      label: 'Type',
      key: 'classificationTypeName'
    },
    {
      label: 'Category',
      key: 'categoryName'
    },
    {
      label: 'Malfunction',
      key: 'malfunctionTypeName'
    },
    {
      label: 'Status',
      key: 'friendlyStatus'
    }
  ];

  settings = {
    name: 'Incident',
    route: 'mars/incident',
    menuItems: [
      {
        label: 'New Incident',
        action: 'new',
        route: 'incidents/new'
      },
      {
        label: 'Edit Incident',
        action: 'edit',
        route: 'incidents/'
      },
      {
        label: 'Delete Incident',
        action: 'delete',
        route: 'incidents/'
      }
    ]
  };
  archived = false;

  constructor(
    private route: ActivatedRoute,
    private toast: ToastService,
    private router: Router,
    private http: HttpClient,    
  ) {}

  ngOnInit() {
    let base = window.sessionStorage.getItem('incidentsBase');
    this.selectedBase.baseCode = base;
    this.selectedBase.value = base;
    if (
      this.userInfo.role === 'admin' ||
      this.userInfo.role === 'baseadmin' ||
      this.userInfo.role === 'sysadmin'
    ) {
      this.isAdmin = true;
    }

    let baseId = window.sessionStorage.getItem('incidentsBaseId');    
    if (baseId) {
      this.selectedBase.baseId = Number(baseId);
    }

    // // populate years dropdown
    // for (let year = new Date().getFullYear(); year > 2003; year--) {
    //   this.years.push({ name: year, value: year });
    // }

    // // select year from session storage to return user to previous view
    // let incidentsYear = Number(window.sessionStorage.getItem('incidentsYear')) === 0 ? 2024 : Number(window.sessionStorage.getItem('incidentsYear'));
    // this.selectedYear = {
    //   name: incidentsYear,
    //   value: incidentsYear
    // };

    this.getBases();

    this.refreshIncidents();
  }

  getBases() {
    let options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };

    axios 
      .get (environment.API_URL + '/base/dropdown/main', options)
      .then((response) => {
         this.bases = response.data;
         for (let base of response.data) {
          this.basesXref.push({ "homeBaseId:": base.Id, name: base.text });
         }
      })
      .catch(function (error) {
        console.log('Error fetching Malf. Data', error);            
      })

    this.refreshIncidents();
  }

  modalConfirmed = (data) => {
    if (data.action === 'delete') {
      this.deleteIncident(data.incident);
    }
    this.modal.active = false;
  };

  modalDenied = (data) => {
    this.modal.active = false;
  };

  confirmDeleteIncident = (incident) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to delete this incident?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        incident: incident
      },
      active: true
    };
  };

  deleteIncident = async (incident) => {
    let userId = this.userInfo.id;
    let id = '';
    var incidentText = "incidents";

    if (incident.id) {
      id = incident.id;
    } else if (incident.incidentId > 0) {
      // this is a MARS incident
      id = incident.incidentId;
      incidentText = "incident";
    } else if (incident.href) {
      id = incident.href.slice(
        incident.href.indexOf('/incidents/') + '/incidents/'.length,
        incident.href.length
      );
    }

    let url = environment.API_URL + '/mars/' + incidentText + '/' + id + '/delete?userId=' + userId;

    axios
      .delete(
        url,
        {
          headers: { Authorization: 'Bearer ' + this.token }
        }
      )
      .then((response) => {
        this.toast.show('Deleted Incident', 'success');
        this.refreshIncidents();
      })
      .catch((error) => {
        this.toast.show('Error deleting Incident', 'error');
      });
  };

  refreshIncidents = async () => {
    this.loading = true;
    let incidents;
    let baseCode = this.selectedBase.baseCode;
    let url =
      environment.API_URL +
        '/mars/incidentlist/fetch?' + 
        'year=0'
    try {
      incidents = await axios.get(url, {
        headers: { Authorization: 'Bearer ' + this.token }
      });
      this.incidents = incidents.data;
      this.loading = false;
      if (this.incidents?.length > 0) {
        // here we format the date for the table
        for (let incident of this.incidents) {
          let date = new Date(incident.incidentDate);
          incident.incidentDate = date.toLocaleDateString();
          incident.status === 0 ? incident.friendlyStatus = 'Draft' : incident.friendlyStatus = 'Finalized';
        }
        
      }
    } catch (error) {
      console.dir(error);
      this.loading = false;
      this.incidents = [];
    };
  }

  getBaseIdFromName = (baseName) => {
    return this.bases.find(x => x.name == baseName).homeBaseId;
  }

  // selectYear = (year) => {
  //   window.sessionStorage.setItem('incidentsYear', year.value.toString());
  //   this.selectedYear = year;
  //   if (year.value === 'current') {
  //     this.archived = false;
  //   } else {
  //     this.archived = true;
  //   }
  //   this.refreshIncidents();
  // };

}
